<template>
    <header-middle />
    <main-slider item="1"/>
    <direct-store />
    <!-- <sale-charge /> -->
    <offers-tabs />
    <main-slider item="2"/>
    <counter-template :areaFlag="areaFlag" />
    <grid-template />
    <footer-template />
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import HeaderMiddle from '../section/header/header.vue'
import MainSlider from "../section/item/SliderTemp.vue";
import DirectStore from "../section/item/directStore.vue";
import CounterTemplate from "../section/item/counter.vue";
// import SaleCharge from "../section/item/sale.vue";
import OffersTabs from "../section/item/arrivals.vue";
import FooterTemplate from "../section/footer/footer.vue";
import GridTemplate from "../section/footer/grids.vue";
let route = useRoute();
let routeName = route.name;
let areaFlag = ref(false)
if (routeName == 'Invite') {
  // کد پیگیری
  document.getElementById('mobileModalBTN').click()
} else if (routeName == 'Poll') {
  // نظرسنجی
  document.getElementById('pollModalBTN').click()
} else if (routeName == 'Track') {
  // پیگیری 
  if (document.getElementById('emptyBasketBTN')) {
    document.getElementById('emptyBasketBTN').click()
  }
  document.getElementById('trackingModalBTN').click()
} else if (routeName == 'Map') {
  // مپ در آدرس سبد خرید
  document.getElementById('mapModalBTN').click()
}

setInterval(getArea, 1000)
function getArea() {
  if (window.innerWidth < 500 && window.scrollY >= 1500) {
    areaFlag.value = true
  } else if (window.innerWidth > 500 && window.scrollY > 1950) {
    areaFlag.value = true
  }
}
</script>

<style>
body {
  margin: 0;
}
* {
  margin: 0;
  padding: 0;
}

</style>